import { useParams, useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { useJobDetail } from '../hooks/useJobs'
import JobResultPanel from '../components/JobResultPanel'
import { Spinner, Empty } from '../components/UI'

export default function JobResultPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { data: job, isLoading, isError } = useJobDetail(id ?? null)

  return (
    <div>
      <button className="btn btn-outline btn-sm" style={{ marginBottom: 20 }} onClick={() => navigate('/queue')}>
        <ArrowLeft size={13} /> Back to Queue
      </button>

      {isLoading && (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '80px 0' }}>
          <Spinner size={32} />
        </div>
      )}

      {isError && (
        <div className="card">
          <Empty
            icon="❌" title="Could not load job results"
            sub="The job may have been deleted or the server is unreachable."
            action={<button className="btn btn-outline" style={{ margin: '0 auto' }} onClick={() => navigate('/queue')}>Back to Queue</button>}
          />
        </div>
      )}

      {job?.status === 'done' && job.result && <JobResultPanel job={job} />}

      {job?.status === 'processing' && (
        <div className="card" style={{ padding: '48px 24px', textAlign: 'center' }}>
          <Spinner size={36} />
          <p style={{ fontWeight: 600, color: 'var(--text-1)', marginTop: 16, marginBottom: 4 }}>Still processing…</p>
          <p style={{ fontSize: 13, color: 'var(--text-2)' }}>Page updates automatically</p>
        </div>
      )}

      {job?.status === 'error' && (
        <div className="card" style={{ border: '1px solid #fecaca', background: '#fef2f2', padding: '40px 24px', textAlign: 'center' }}>
          <p style={{ fontWeight: 700, fontSize: 18, color: '#b91c1c', marginBottom: 8 }}>Processing Failed</p>
          <p style={{ fontSize: 13, color: '#ef4444', marginBottom: 20 }}>{job.error_message}</p>
          <button className="btn btn-outline" style={{ margin: '0 auto' }} onClick={() => navigate('/upload')}>Try Another File</button>
        </div>
      )}
    </div>
  )
}
